import {withClassNames} from 'quickstart/theme'
import S from './styles.module.css'

export const Wrapper = withClassNames(S.wrapper)('label')

export const RadioColumn = withClassNames(S['radio-column'])('div')

export const Radio = withClassNames(S.radio)('input')

export const Label = withClassNames(S.label)('div')
